
  import { Component, Vue } from 'vue-property-decorator'

  import DropdownNavigation from '@/components/elements/DropdownNavigation.vue'
  import LoginForm from '@/components/forms/LoginForm.vue'
  import { environment } from '@/helpers/Environment'
  import { isLoggedIn } from '@/state/Authentication'
  import { isCurrentOrPastMember } from '@/state/Membership'

  export type NavigationSection = Array<{
    title?: string
    disabled?: boolean
    items: NavigationRoute[]
  }>

  @Component({
    components: { DropdownNavigation, LoginForm },
  })
  export default class MyAccountRoute extends Vue {
    get navigationSections(): NavigationSection {
      const pageConfig = environment.config.my_account_pages

      const result: NavigationSection = [
        {
          title: 'Membership',
          disabled: !this.hasMembership,
          items: [
            {
              label: 'My membership details',
              route: '/my/membership',
              icon: 'StarIcon',
            },
          ],
        },
      ]

      const ticketsSubpages: NavigationRoute[] = []

      if (pageConfig?.my_profile) {
        result.push({
          title: 'Profile',
          items: [
            {
              label: 'My profile',
              route: '/my/profile',
              icon: 'UserIcon',
            },
          ],
        })
      }

      if (pageConfig?.upcoming_events) {
        ticketsSubpages.push({
          label: 'My upcoming tickets',
          route: '/my/upcoming',
          icon: 'TicketIcon',
        })
      }

      if (pageConfig?.recent_orders) {
        ticketsSubpages.push({
          label: 'My recent orders',
          route: '/my/orders',
          icon: 'ClockRotateLeftIcon',
        })
      }

      if (ticketsSubpages.length > 0) {
        result.push({
          title: 'Tickets',
          items: ticketsSubpages,
        })
      }

      result.push({
        items: [
          {
            label: 'Logout',
            route: '/logout',
            icon: 'LogoutIcon',
          },
        ],
      })

      return result
    }

    get activeRoute() {
      return this.$route.path
    }

    get isLoggedIn(): boolean {
      return isLoggedIn()
    }

    get hasMembership(): boolean {
      return isCurrentOrPastMember()
    }

    get flatRoutes() {
      return this.enabledNavSections.map((section) => section.items).flat()
    }

    get enabledNavSections() {
      return this.navigationSections.filter((section) => !section.disabled)
    }
  }
